import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=2fdd5384"
import script from "./CopyToClipboard.vue?vue&type=script&lang=js"
export * from "./CopyToClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports